// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    appKey: 'LDD_DEV',
    version: require('../../package.json').version,
    projectName: require('../../package.json').name,
    redirectOnLogout: true,
    redirectOnInternalServerError: true,
    logHttpRequests: true,
    logClientErrors: true,
    showClientErrorMessageDetail: true,
    menu: {
        excludedMenuItems: ['mnuOrders', 'mnuSettings']
    },

};

//Take from assets/configs.json
